import React from 'react';
import SecurityIcon from '@mui/icons-material/Security';
import { Box, Typography } from '@mui/material';
import LegalLayout, { Section, P, Ul } from './LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="Last updated: 25 July 2026 · Home Billing POS (homebillingpos.com)"
      icon={SecurityIcon}
    >
      <Section title="1. Introduction">
        <P>
          Home Billing POS (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) provides restaurant point-of-sale software,
          mobile companion apps, counter PC desktop software, and the owner cloud portal at
          homebillingpos.com. This Privacy Policy explains how we collect, use, store, and protect
          information when you use our website, owner portal, desktop POS, and mobile apps.
        </P>
      </Section>

      <Section title="2. Information we collect">
        <P>We collect information needed to run licensing, billing, and product operations:</P>
        <Ul
          items={[
            <><strong>Account &amp; profile:</strong> name, email, phone, restaurant/business name, and address when you register or manage your account.</>,
            <><strong>Operational POS data:</strong> menu, tables, orders, billings, and related records stored primarily on your counter hardware; limited cloud records for licensing, branches, and invoices.</>,
            <><strong>Device &amp; technical data:</strong> device identifiers used for license activation, connection diagnostics, and error logs.</>,
            <><strong>Analytics:</strong> aggregate site usage via Google Analytics (G-ZGEMDCK6KG) on the owner portal to improve performance and product experience.</>,
            <><strong>Payments:</strong> payment status and order references from our payment provider (PayU) for branch subscriptions; we do not store full card numbers on our servers.</>,
          ]}
        />
      </Section>

      <Section title="3. How we use your information">
        <Ul
          items={[
            'Provide the owner portal, license keys, branch management, and subscription billing.',
            'Enable counter PC activation and local LAN sync with staff mobile devices.',
            'Generate invoices and support GST-related billing records where applicable.',
            'Prevent fraud, abuse, and unauthorized redistribution of the software.',
            'Respond to support requests (support@homebillingpos.com).',
          ]}
        />
      </Section>

      <Section title="4. Data security & local storage">
        <P>
          Primary order and menu data is designed to live on your counter PC (offline-first). Cloud
          services use encrypted HTTPS connections. Passwords and tokens are stored using industry-standard
          hashing and secure session practices. You are responsible for securing your counter PC, Wi‑Fi,
          and staff access.
        </P>
      </Section>

      <Section title="5. Sharing with third parties">
        <P>
          We do not sell your restaurant sales data. We share data only with essential processors such as
          payment gateways (e.g. PayU), hosting providers, and analytics tools, under appropriate
          confidentiality and data-processing arrangements.
        </P>
      </Section>

      <Box>
        <Typography variant="h6" fontWeight={700} gutterBottom color="primary.main">
          6. Contact
        </Typography>
        <P>
          For privacy questions or data deletion/export requests related to your owner account:
        </P>
        <Box sx={{ bgcolor: 'rgba(79,70,229,0.06)', p: 3, borderRadius: 3, border: '1px solid rgba(79,70,229,0.15)' }}>
          <Typography variant="subtitle2" fontWeight={700}>Home Billing POS Support</Typography>
          <Typography variant="body2" color="text.secondary">Email: support@homebillingpos.com</Typography>
          <Typography variant="body2" color="text.secondary">Phone: +91 98677 65397</Typography>
          <Typography variant="body2" color="text.secondary">Website: https://www.homebillingpos.com</Typography>
        </Box>
      </Box>
    </LegalLayout>
  );
}
